import { AxiosResponse } from "axios";
import axiosInstance from "../core/axios";
import {
  ACHTransaction,
  BaseTransaction,
  CheckTransaction,
  TransferTransaction,
  WireTransaction,
  UpdateTransaction
} from "../types/transactionType";
import { apiEndPoints } from "../variables/apiEndpoints";
import { DropdownOptions } from "../components/common/Dropdown/Dropdown";
import { AccountType, TransactionDataType, TransactionDetailsType } from "../types/genericType";

type GetClientsResponse = DropdownOptions[];
type GetAccountsResponse = AccountType[];

export const getTransactions = async (
  startDate: string,
  endDate: string,
  excludeTransactionCodes?: string,
  distributionId?: string,
): Promise<TransactionDataType[]> => {
  try {
    const params: any = {};
    
    if (distributionId) {
      params.distributionId = distributionId;
      // Don't include dates when distributionId is provided
    } else {
      params.startDate = startDate;
      params.endDate = endDate;
    }
    
    if (excludeTransactionCodes) {
      params.excludeTransactionCodes = excludeTransactionCodes;
    }
    
    const response: AxiosResponse<TransactionDataType[]> =
      await axiosInstance.get(`${apiEndPoints.transactions}`, {
        params,
      });
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getTransactionsById = async (
  id: number,
): Promise<TransactionDetailsType> => {
  try {
    const response: AxiosResponse<TransactionDetailsType> =
      await axiosInstance.get(`${apiEndPoints.transactions}/${id}`);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getClients = async (): Promise<GetClientsResponse> => {
  try {
    const response: AxiosResponse<GetClientsResponse> = await axiosInstance.get(
      `${apiEndPoints.investors}`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getAccountByClientId = async (
  clientId: String
): Promise<GetAccountsResponse> => {
  try {
    const response: AxiosResponse<GetAccountsResponse> =
      await axiosInstance.get(`${apiEndPoints.investors}/${clientId}/accounts`);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const createTransaction = async (
  body:
    | BaseTransaction
    | TransferTransaction
    | CheckTransaction
    | ACHTransaction
    | WireTransaction
    | null,
  transactionType: string,
  method: string
) => {
  const endpoint =
    body?.transactionType === 2
      ? `${apiEndPoints.transactions}/withdraw/${method}`
      : `${apiEndPoints.transactions}/${transactionType}`;
  try {
    const response = await axiosInstance.post(endpoint, body);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const updateTransaction = async (
  body:
    | UpdateTransaction
    | null,
  id: number
) => {
  const endpoint = `${apiEndPoints.transactions}/${id}`;
  try {
    const response = await axiosInstance.put(endpoint, body);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const voidTransaction = async (transactionId: number) => {
  try {
    const response = await axiosInstance.post(
      `${apiEndPoints.transactions}/${transactionId}/void`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};
